<template>
  <div style="width: 100%">
    <div
      v-for="(friend, index) in friends"
      :key="index"
      :class="{'md-layout user': true, 'gray-background': index % 2 === 1}"
    >
      <user-avatar
        class="md-layout-item md-size-60"
        :title="friend.displayName"
        :image="friend.image"
      />
      <md-button
        v-if="showButton && preselectedFriends.includes(friend._id)"
        class="md-simple cancel-invite md-layout-item md-size-35"
        @click="onCancelInvite(friend._id)"
      >
        <span class="button">{{ cancelButtonText }}</span>
      </md-button>
      <md-button
        v-if="showButton && !preselectedFriends.includes(friend._id)"
        class="md-danger md-layout-item md-size-35"
        @click="onSendInvite(friend._id)"
      >
        <span class="button">{{ acceptButtonText }}</span>
      </md-button>
    </div>
  </div>
</template>

<script>
import UserAvatar from '../atoms/user-avatar';
export default {
  name: 'UsersList',
  components: { UserAvatar },
  props: {
    friends: {
      type: Array,
    },
    preselectedFriends: {
      type: Array,
    },
    showButton: {
      type: Boolean,
    },
    acceptButtonText: {
      type: String,
      default: 'sende Einladung',
    },
    cancelButtonText: {
      type: String,
      default: 'Einladung abbrechen',
    }
  },
  methods: {
    onSendInvite(id) {
      this.$emit('onSendInvite', id);
    },
    onCancelInvite(id) {
      this.$emit('onCancelInvite', id);
    }
  }
}
</script>

<style lang="scss">
.user {
  padding: 8px 12px;
}

.gray-background {
  background-color: #FAF5F5
}

.cancel-invite {
  .md-button-content {
    color: #005FB6;
  }
  border: 1px solid #005FB6;
}
.button {
  font-size: 14px;
  font-weight: 500;
}
</style>